module.exports = __webpack_public_path__ + "img/dashboard-header-image@3x.468b1995.png";